import { render, staticRenderFns } from "./ResultsAnalysisPageHeader.vue?vue&type=template&id=7f56bfea&scoped=true&"
import script from "./ResultsAnalysisPageHeader.vue?vue&type=script&lang=ts&"
export * from "./ResultsAnalysisPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ResultsAnalysisPageHeader.vue?vue&type=style&index=0&id=7f56bfea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56bfea",
  null
  
)

export default component.exports